import * as yup from "yup";

export const validationSchema = yup.object().shape({
  anonId: yup.string().required("Anon ID is required."),
  password: yup.string().required("Password is required."),
});

export const INIT_VALUES = { firstName: "", lastName: "", email: "", university: "", username: "", password: "", passwordConfirm: "" };
